import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';


class SetupOperation extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {manageaction:'NOTICE',Items:[], comments:'', Resp:'',updaterole:'', admin:'', human:'',user:localStorage.getItem('tokens')};
		this.handleChange=this.handleChange.bind(this)		
		this.handleAddChange=this.handleAddChange.bind(this)
		this.handleSubmit=this.handleSubmit.bind(this)
	}
	componentDidMount() {	
		const para={user:this.state.user}		
		axios.post(process.env.REACT_APP_API_ENV+'api/updatenews.php')			
			.then(result => {
				this.setState({Items:result.data})								
			})			
	}
	handleAddChange = event => {				
		const {name, value} = event.target
		this.setState({[name]: value}) 		
		this.setState({comments:this.state.Items.filter(sub=>sub[0]==event.target.value).map(sub=>sub[1])[0]})
		this.setState({admin:this.state.Items.filter(sub=>sub[0] === event.target.value).map(sub=>sub[4])[0]})
		this.setState({human:this.state.Items.filter(sub=>sub[0] === event.target.value).map(sub=>sub[5])[0]})				
		this.setState({Resp:''})
	}	
	handleChange = event => {				
		const {name, value} = event.target
		this.setState({[name]: value}) 		
		this.setState({Resp:''})
	}	
	handleSubmit = event => {
		event.preventDefault()		
		const {updaterole,admin, human,comments} = this.state		
		if(!updaterole){
			alert('Please select notice')
			return false 
		} 			
		if(!comments){
			alert('Please write down or update your notice description')
			return false 
		} 
		if(!admin){
				alert('Please enter the start date for your notice')
				return false 
			} 
		if(!human){
			alert('Please enter the ending date for your notice')
			return false 
		} 		
		const userObject = {	
			user:this.state.user,
			manageaction:this.state.manageaction,
			updaterole:this.state.updaterole,						
			admin: this.state.admin,
			human: this.state.human,						
			comments:this.state.comments
		};
		axios.post(process.env.REACT_APP_API_ENV+'api/managementprocess.php', userObject)
			.then((res) => {
				this.setState({Resp:res.data})											
			}).catch((error) => {
				console.log(error)
			});
		
	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Notice"/>	
				<form onSubmit={this.handleSubmit}>
					<h3>Select Notice</h3>
					<select name="updaterole" style={{width: '150px', border:'1px solid grey'}} value = {this.state.updaterole} onChange={this.handleAddChange}>
						<option value="">--Select--</option>		
						{this.state.Items.map((sub,index) => (<option value={sub[0]} key={index}>{sub[0]}</option>))}
					</select><br/><br/>	
					{(()=>{if(this.state.updaterole != "") {return (<div>							
						<h3>Please update the following <small>If no description, please enter 0</small>:</h3>
						<label style={{width: '200px',display:'inline-block',textAlign:'right', verticalAlign:'top', marginRight:'5px'}}><b>{this.state.updaterole+' description'}:</b></label>
						<textarea name="comments" id="comments" rows="5" value = {this.state.comments} style={{width: '300px',border:'1px solid #4195fc'}} onChange={this.handleChange} /><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right', marginRight:'5px'}}><b>Start Date (inclusive):</b></label>
						<input type="text" name="admin" style={{width: '300px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.admin} onChange={this.handleChange} /><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right', marginRight:'5px'}}><b>End Date (inclusive):</b></label>
						<input type="text" name="human" style={{width: '300px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.human} onChange={this.handleChange} /><br/>
						<small>If no specific ending date, please enter 9999-12-31</small><br/><br/>						
					</div>)}})()}
					<h3>{this.state.Resp}</h3><br/><br/>
					<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
				</form>				
			</div>
		)
	}
}

export default SetupOperation